module.exports = __webpack_public_path__ + "img/unit_w_shadow.088fe818.svg";